import React, { useState, useEffect } from 'react';
import { useEffects, Effect } from '@/hooks/useEffects';
import '@/styles/effects.css';

interface EffectsDisplayProps {
  className?: string;
}

const EFFECT_ICON: Record<Effect['type'], string> = {
  success: '✓',
  error: '✗',
  achievement: '★',
  reward: '◈',
  click: '•',
  hover: '»',
};

export const EffectsDisplay: React.FC<EffectsDisplayProps> = ({ className = '' }) => {
  const { effects, clearEffects } = useEffects();
  const [visibleEffects, setVisibleEffects] = useState<Effect[]>([]);

  useEffect(() => {
    setVisibleEffects(effects);
    if (effects.length === 0) return undefined;
    const timer = setTimeout(() => {
      clearEffects();
    }, 10000);
    return () => clearTimeout(timer);
  }, [effects, clearEffects]);

  return (
    <div className={`effects-display ${className}`}>
      {visibleEffects.map((effect) => (
        <div key={effect.id} className={`effect-notification ${effect.type}`}>
          <div className="effect-icon">{EFFECT_ICON[effect.type] || '•'}</div>
          <div className="effect-message">{effect.message}</div>
        </div>
      ))}
    </div>
  );
};
